export default __webpack_public_path__ + "static/freidora-inox-414a8d5272c46347bca8e7488fbb2d4e.png";